import React from "react";
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import LuckyNumberLinks from 'affiliate/LuckyNumberLinks';

export function highlight(text, highlight) {
  
  if (!highlight){
      return text;
  }

  if (highlight === null || highlight?.length === 0 || highlight === " " || highlight === ","){
    return text;
  }
  // Split text on highlight term, include term itself into parts, ignore case
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  return <span>{parts.map((part,i) => part.toLowerCase() === highlight.toLowerCase() ? <mark key={i} className="highlight-match">{part}</mark> : part)}</span>;
}

export function directHighlight(text) {
  return <span className="highlight-match">{text}</span>;
}

export function setQueryHyperlink(text, slug) {
  return <LuckyNumberLinks text={text} slug={slug} />;
}

export function hintTypeDescription(hintType){
  if (hintType === "CALENDAR_CHINESE01"){
      return "เลขปฎิทินจีน";
  } 
  else if (hintType === "CALENDAR_KUMCHANOD"){
      return "เลขคำชะโนด";
  }
  return "N/A";
}

export function getLottoThDate(date){

      if (date){
            date = date?.substring(0, date?.length - 2).replace(" ","T") + "Z";
      }

      return "งวด " + (new Date(date)).toLocaleDateString('th-TH',{year: 'numeric', month: 'short', day: '2-digit'});
}

export function getThDate(date){

      if (date){
            date = date?.substring(0, date?.length - 2).replace(" ","T") + "Z";
      }

      return (new Date(date)).toLocaleDateString('th-TH',{year: 'numeric', month: 'short', day: '2-digit'});
}

export {
  buildPageTitle as prepareTxtTitle,
  buildPageDescription as prepareTxtDescription,
  buildKeywords as prepareTxtKeywords,
  buildCanonicalUrl as prepareTxtCanonicalUrl,
} from 'seo/seoConfig';
